import { Listbox, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import EventLabel from '../../../components/EventLabel/EventLabel';

interface ISortByMenuProps {
  sortBy: string;
  onChange: (sortBy: string) => void;
}

const sortOptions = [
  { name: 'Name', value: 'name' },
  { name: 'Company', value: 'company' },
  { name: 'Title', value: 'title' },
  { name: 'Country', value: 'country' },
];

export default function SortByMenu({ sortBy, onChange }: ISortByMenuProps) {
  return (
    <Listbox value={sortBy} onChange={(opt: any) => onChange(opt.value)}>
      <div className="relative lg:w-64  w-full input rounded-lg">
        <Listbox.Button className="relative w-full cursor-default rounded-lg    py-2 pl-3 pr-10 text-left  focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm">
          <span className="block truncate">
            <EventLabel name={sortOptions.find(option => option.value === sortBy)?.name || 'Sort By'} groupName="Cms.AttendeeList" />
          </span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <i className="ri-sort-desc"></i>
          </span>
        </Listbox.Button>
        <Transition as={Fragment} leave="transition ease-in duration-100 " leaveFrom="opacity-100" leaveTo="opacity-0">
          <Listbox.Options className="absolute flex flex-col  mt-1 p-0 max-h-60  z-20 w-full overflow-auto rounded-md bg-white text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
            {sortOptions.map(option => (
              <Listbox.Option
                as="div"
                key={option.value}
                className="flex relative items-center cursor-pointer pl-10 py-2 gap-x-2 w-full hover:bg-slate-100"
                value={option}
              >
                {option.value === sortBy && (
                  <span className="flex items-center absolute left-3  text-[teal]">
                    <i className="ri-check-line"></i>
                  </span>
                )}

                <span className={`block truncate ${option.value === sortBy ? 'font-semibold' : 'font-normal'}`}>
                  <EventLabel name={option.name} groupName="Cms.AttendeeList" />
                </span>
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
}
